import { render, staticRenderFns } from "./BusinessCardBack.vue?vue&type=template&id=25f5b510&scoped=true"
import script from "./BusinessCardBack.vue?vue&type=script&lang=js"
export * from "./BusinessCardBack.vue?vue&type=script&lang=js"
import style0 from "./BusinessCardBack.vue?vue&type=style&index=0&id=25f5b510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f5b510",
  null
  
)

export default component.exports